<template lang="pug">
//- Adding 'tw-' prefix until card.styl is fully replaced
div(class="tw-card relative w-full bg-white")
    header(
        class="header flex items-stretch"
        :class="{'bg-black text-light': headerIsDark}"
    )
        span(class="flex grow items-center font-bold p-3")
            slot(name="title")
    div(v-bind="$attrs" class="p-5")
        slot
</template>

<script>
export default {
    name: 'Card',
    inheritAttrs: false,
    props: {
        headerIsDark: {
            type: Boolean,
            default: false,
        },
    },
}
</script>

<style lang="stylus" scoped>
.tw-card
    box-shadow: 0 2px 3px alpha(#000000, 0.1), 0 0 0 1px alpha(#000000, 0.1)
    .header
        margin: -1px -1px 0
        box-shadow: 0 1px 2px rgba(#000000, 0.1)
</style>
